import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BracketIcon from '@/assets/bracketIcon.svg';
import CircleLocationIcon from '@/assets/circleLocationIcon.svg';
import ArrowIcon from '@/assets/arrowIcon.svg';
import InformIcon from '@/assets/informIcon.svg';

interface TableCellInputs {
  title: string;
  description: string;
  showLeftIcon: boolean;
  iconLeftType: 'bracket' | 'circleLocation' | 'arrow' | 'inform';
  showRightIcon: boolean;
  iconRightType: 'bracket' | 'circleLocation' | 'arrow' | 'inform';
  onAction: () => void;
}

export const TableCell = ({
  title,
  description,
  showLeftIcon,
  iconLeftType,
  showRightIcon,
  iconRightType,
  onAction,
}: TableCellInputs) => {
  const { t } = useTranslation('appointmentDetails');

  function icon(type: string) {
    switch (type) {
      case 'bracket':
        return BracketIcon;
      case 'circleLocation':
        return CircleLocationIcon;
      case 'arrow':
        return ArrowIcon;
      case 'inform':
        return InformIcon;
      default:
        return BracketIcon;
    }
  }
  return (
    <Box
      sx={{
        borderTop: '0px',
        borderBottom: '1px solid #EAEAEA',
        cursor: 'pointer',
      }}
      onClick={() => onAction()}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignContent: 'center',
            paddingTop: 2.8,
            paddingBottom: 2.8,
            paddingLeft: 2.4,
            paddingRight: 1.6,
          }}
        >
          {showLeftIcon && <img src={icon(iconLeftType)} alt="icon" />}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Typography
            sx={{
              fontSize: '1.0rem',
              fontWeight: 600,
            }}
          >
            {t(title)}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.2rem',
              fontWeight: 400,
            }}
          >
            {t(description)}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            paddingTop: 2.8,
            paddingBottom: 2.8,
            paddingRight: 2.4,
          }}
        >
          {showRightIcon && <img src={icon(iconRightType)} alt="icon" />}
        </Box>
      </Box>
    </Box>
  );
};
